import React, { useState } from "react";
import { FORM_FIELDS, PRICE_LIST_TABLE_COLUMNS } from "../../Constants";
import PosTable from "./PosTable";
import { Button, Card, Accordion } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

const StoresPreveiwList = ({
  stores,
  setStores,
  showUpdateModal,
  priceListStep,
  showPriceListTable = true,
}) => {
  const { STORE_DATA } = FORM_FIELDS;
  const { PRICE_LIST_DATA } = STORE_DATA;

  const [activeKey, setActiveKey] = useState(0);

  return (
    <Accordion
      activeKey={activeKey}
      style={{ margin: "20px 0" }}
      className={`public-onboarding-accordion`}
    >
      {stores.map((data, index) => (
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            eventKey={index}
            onClick={() =>
              setActiveKey(activeKey === index ? undefined : index)
            }
          >
            <span>
              {"Naziv: "} {data?.[STORE_DATA.DESCRIPTION.name]} /{" OZNAKA:"}
              {data?.[STORE_DATA.TAG.name]} / {"Adresa:"}{" "}
              {data?.[STORE_DATA.STREET.name]}{" "}
              {data?.[STORE_DATA.STREET_NUMBER.name]}
            </span>
            <i
              className={`fas fa-chevron-${
                activeKey === index ? "down" : "right"
              }`}
            ></i>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey={index}>
            <Card.Body>
              {setStores && (
                <div className="d-flex align-items-center justify-content-end">
                  <Button
                    variant="outline-secondary ml-3"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      showUpdateModal(data);
                    }}
                  >
                    <i className="icon icon-trash mr-2" />
                    {priceListStep ? "Dodaj cjenik" : "Uredi"}
                  </Button>
                  {!priceListStep && (
                    <Button
                      variant="outline-secondary ml-3"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setStores((stores) =>
                          stores.filter((store) => store.tag !== data.tag)
                        );
                      }}
                    >
                      <i className="icon icon-trash mr-2" />
                      Izbriši
                    </Button>
                  )}
                </div>
              )}

              <div className="row">
                <div className="col-md-6">
                  <h6>Matični podaci</h6>
                  <ul className="list-group">
                    <li className="list-group-item">
                      <strong>{STORE_DATA.DESCRIPTION.title}:</strong>{" "}
                      {data?.[STORE_DATA.DESCRIPTION.name]}
                    </li>
                    <li className="list-group-item">
                      <strong>{STORE_DATA.TAG.title}:</strong>{" "}
                      {data?.[STORE_DATA.TAG.name]}
                    </li>
                    <li className="list-group-item">
                      <strong>{STORE_DATA.TYPE.title}:</strong>{" "}
                      {data?.[STORE_DATA.TYPE.name]}
                    </li>
                    <li className="list-group-item">
                      <strong>{STORE_DATA.FOOTER_NOTE.title}:</strong>{" "}
                      {data?.[STORE_DATA.FOOTER_NOTE.name]}
                    </li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h6>Podaci o adresi</h6>
                  <ul className="list-group">
                    <li className="list-group-item">
                      <strong>{STORE_DATA.STREET.title}:</strong>{" "}
                      {data?.[STORE_DATA.STREET.name]}
                    </li>
                    <li className="list-group-item">
                      <strong>{STORE_DATA.STREET_NUMBER.title}:</strong>{" "}
                      {data?.[STORE_DATA.STREET_NUMBER.name]},{" "}
                      {data?.[STORE_DATA.STREET_NUMBER_EXTENSTION.name]}
                    </li>
                    <li className="list-group-item">
                      <strong>{STORE_DATA.POSTAL_NUMBER.title}:</strong>{" "}
                      {data?.[STORE_DATA.POSTAL_NUMBER.name]?.value}
                    </li>
                    <li className="list-group-item">
                      <strong>{STORE_DATA.CITY.title}:</strong>{" "}
                      {data?.[STORE_DATA.CITY.name]}
                    </li>
                  </ul>
                </div>
                <div className="col-lg-12 my-3">
                  <h6>Blagajne</h6>
                  <PosTable data={data?.[STORE_DATA.POS_DATA.name]} />
                </div>
                <div className="col-lg-12">
                  {showPriceListTable && (
                    <>
                      <h6>Cjenik</h6>
                      <BootstrapTable
                        keyField={PRICE_LIST_DATA.ID.name}
                        data={data?.priceListTableData || []}
                        columns={PRICE_LIST_TABLE_COLUMNS}
                        noDataIndication={"Nema podataka"}
                        pagination={paginationFactory()}
                      />
                    </>
                  )}
                </div>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      ))}
    </Accordion>
  );
};

export default StoresPreveiwList;
